export const AnalyticsBoardGraphLineIcon = () => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2.04082 4.08163C1.81539 4.08163 1.63265 4.26437 1.63265 4.48979V15.5102C1.63265 15.7356 1.81539 15.9184 2.04082 15.9184H17.9592C18.1846 15.9184 18.3673 15.7356 18.3673 15.5102V4.48979C18.3673 4.26437 18.1846 4.08163 17.9592 4.08163H2.04082ZM0 4.48979C0 3.36268 0.913705 2.44897 2.04082 2.44897H17.9592C19.0863 2.44897 20 3.36268 20 4.48979V15.5102C20 16.6373 19.0863 17.551 17.9592 17.551H2.04082C0.913705 17.551 0 16.6373 0 15.5102V4.48979Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M17.1875 6.25955C17.5626 6.50963 17.664 7.01646 17.4139 7.39159L13.7404 12.9018C13.6048 13.1053 13.385 13.2372 13.1417 13.2613C12.8983 13.2854 12.6569 13.1991 12.484 13.0262L10.6122 11.1545L8.7405 13.0262C8.55838 13.2083 8.30099 13.2938 8.0461 13.2568C7.79121 13.2199 7.56871 13.0648 7.44583 12.8384L5.80128 9.809L3.9653 12.869C3.73334 13.2556 3.23191 13.3809 2.84531 13.149C2.45871 12.917 2.33335 12.4156 2.56531 12.029L5.13674 7.74326C5.2875 7.492 5.56136 7.34081 5.85432 7.34712C6.14727 7.35343 6.41437 7.51627 6.55417 7.7738L8.3591 11.0987L10.035 9.42277C10.3538 9.10397 10.8707 9.10397 11.1895 9.42277L12.9343 11.1676L16.0555 6.48595C16.3056 6.11083 16.8124 6.00946 17.1875 6.25955Z'
        fill='currentColor'
      />
    </svg>
  )
}
